import React, { Component } from 'react';
import Image from 'next/image';
import { message, Pagination, List, Row, Col } from 'antd';
import articleList from '../../api/articleApi';
import { timerFormat } from '../../utils/utils';

import defaultImg from '../../public/images/hidream-admin-bg.jpg';

export class ArticleList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      limit: 6,
      total: '',
      articleListData: [],
    };
  }

  componentDidMount() {
    this.getArticleList();
  }

  getArticleList = () => {
    const data = {
      page: this.state.page,
      limit: this.state.limit,
    };

    articleList(data).then((res) => {
      if (res.status === 200) {
        this.setState({
          articleListData: res.data.data.data,
          total: res.data.data.total,
        });
      } else {
        let error_msgs = '',
          msgs = res.data.msg;
        if (typeof msgs == 'object') {
          Object.keys(msgs).forEach((key) => {
            return (error_msgs += `${msgs[key]};`);
          });
        } else {
          error_msgs = msgs;
        }
        message.error(error_msgs);
      }
    });
  };

  /** 当前页码 */
  onChangeCurrnePage = (page, pageSize) => {
    if (page < 1) {
      page = this.state.page;
    }

    const data = {
      page: page,
      limit: pageSize,
    };

    articleList(data).then((res) => {
      if (res.status === 200) {
        this.setState({
          articleListData: res.data.data.data,
          total: res.data.data.total,
        });

        window.scrollTo(0, 0);
      }
    });
  };

  render() {
    const { articleListData, total } = this.state;

    return (
      <div className="articleList">
        <List
          itemLayout="vertical"
          pagination={false}
          dataSource={articleListData}
          renderItem={(item) => (
            <List.Item key={item.title} className="listItem">
              <div className="listImg">
                <a href={item.link} target="_blank" rel="noreferrer">
                  <Image
                    src={item.mobile_src ? `${item.mobile_src}` : defaultImg}
                    alt={item.title}
                    width={750}
                    height={320}
                  />
                </a>
              </div>

              <div className="listContent">
                <div className="header">
                  <a href={item.link} target="_blank" rel="noreferrer">
                    <div className="title">{item.title}</div>
                    <p className="description">
                      {item.description ? item.description : ''}
                    </p>
                  </a>
                </div>

                <Row justify="space-between" align="middle">
                  <Col className="origin">
                    <div className="img">
                      <Image
                        src={require('../../public/images/hi.png').default}
                        alt="Hidream"
                      />
                    </div>
                    讯梦国际
                  </Col>
                  <Col className="time">
                    {item.updated_at
                      ? timerFormat(item.updated_at)
                      : item.updated_at}
                  </Col>
                </Row>
              </div>
            </List.Item>
          )}
        />

        <Pagination
          total={total}
          onChange={this.onChangeCurrnePage}
          pageSize={this.state.limit}
          hideOnSinglePage={true}
        />
      </div>
    );
  }
}

export default ArticleList;
